import { render, staticRenderFns } from "./edit-industry.vue?vue&type=template&id=2ddb4cb7&"
import script from "./edit-industry.vue?vue&type=script&lang=js&"
export * from "./edit-industry.vue?vue&type=script&lang=js&"
import style0 from "./edit-industry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports